/**
 * MKS-314 follow-up — client for `GET /api/reporting-rates`.
 *
 * Backend contract: `authenticate`-only (NOT admin — every signed-in user
 * reads money figures), returning the per-month rates from the CZK ledger into
 * the instance's reporting currency, plus the basis each rate was read on.
 *
 * With the MKS-314 release flag off the backend answers `converted: false`
 * with no months, which `useReportingFxSync` installs as "no conversion".
 */
import { apiGet } from './client';
import type { RateBasisKind } from '../../utils/reportingMoney';

export interface ReportingRateMonth {
  month: string;
  rate: number;
  basis: RateBasisKind;
  rateDate: string | null;
}

export interface ReportingRates {
  reportingCurrency: string;
  ledgerCurrency: string;
  converted: boolean;
  source: string | null;
  months: ReportingRateMonth[];
  unavailableMonths: string[];
}

export async function fetchReportingRates(): Promise<ReportingRates> {
  const res = await apiGet<{ data: ReportingRates }>('/reporting-rates');
  return res.data;
}
